const img = require('./banner-mobile-janeiro-2025.png');
const img2 = require('./banner1-julho2024-mobile.jpg');
const img3 = require('./banner2-julho2024-mobile.jpg');
const img4 = require('./banner-novo-agosto-mobile-v2.jpg');
const img5 = require('./banner4-mobile2-2024.jpg');
const img6 = require('./teste.jpg');
const img7 = require('./banner3-mobile2-2024.jpg');
const img8 = require('./banner2-mobile2-2024.jpg');

export const imgsMobile = [img, img2, img3, img4, img5, img6, img7, img8];
